<template>
  <div class="before">
    <!-- <p>{{nutrients}}</p> -->
    <Item
      v-for="item in nutrients"
      v-if="typeof data[item.key.slice(1) + '_Val'] !== 'undefined'"
      :data="data"
      :item="item"
      :name="item.key.slice(1) + '_Val'"
    />

    <div>
      <span class="weight">
        {{ $ml.get(`Total N:`) }} {{totalN}}
      </span>
    </div>
  </div>
</template>

<script>
import Item from './item';

export default {
  props: {
    data: Object
  },
  data () {
    return {
      nutrients: this.$store.getters['nutrients/nForms']
    }
  },
  computed: {
    totalN() {
      return (+this.data['NO3_Val'] + +this.data['NH4_Val'] + +this.data['NH2_Val']).toFixed(2)
    }
  },
  components: {
    Item
  },
}
</script>

<style lang="scss" scoped>
  .before {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 110px;
      margin: 15px;

      span > div {
        padding: 1px;
      }

      // &:last-child {
      //   width: auto;
      // }
    }

    .weight {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #4C5056;
    }
    @media (max-width: 768px) {
      justify-content: space-between;
      > div {
        width: calc(50% - 8px);
        margin: 0 0 32px 0;
        &:last-child {
          width: calc(50% - 8px);
        }
      }
    }
  }
</style>
